import { B, fonts, Btn } from "../../../components/UI";

// Banners tab is split out so homepage banner issues can be debugged independently.
export default function BannersTab({
  banners,
  showBanFm,
  setShowBanFm,
  editBan,
  setEditBan,
  nextBannerOrder,
  setCrudBusy,
  showToast,
  handleDeleteBanner,
  BannerForm,
}) {
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
        <p style={{ margin: 0, fontSize: 12, color: B.textLight, fontFamily: fonts.body }}>Homepage slider</p>
        {!showBanFm && !editBan && <Btn onClick={() => setShowBanFm(true)} variant="primary">+ Add Banner</Btn>}
      </div>
      {(showBanFm || editBan) && (
        <BannerForm initial={editBan} nextOrder={nextBannerOrder()}
          onDone={() => { setShowBanFm(false); setEditBan(null); }}
          showToast={showToast}
          onSavingChange={setCrudBusy} />
      )}
      {banners.length === 0
        ? <div style={{ textAlign: "center", padding: 48, color: B.textLight, background: B.white, borderRadius: 12, border: `1px dashed ${B.border}`, fontFamily: fonts.body }}>No banners yet.</div>
        : banners.map(b => (
          <div key={b.id} style={{ display: "flex", alignItems: "center", gap: 14, padding: "12px 16px", background: B.white, border: `1px solid ${B.borderLight}`, borderRadius: 12, marginBottom: 8 }}>
            <div style={{ width: 88, height: 50, background: B.orangeFaint, borderRadius: 6, overflow: "hidden", flexShrink: 0 }}>
              {b.imageUrl && <img src={b.imageUrl} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: B.text, fontFamily: fonts.adminDisplay }}>{b.title || "(No title)"}</div>
              <div style={{ fontSize: 11, color: B.textLight, fontFamily: fonts.body }}>
                {b.subtitle} · Order: {b.order}{b.videoUrl ? " · 🎥 Video URL set" : ""}
              </div>
            </div>
            <div style={{ display: "flex", gap: 6 }}>
              <Btn onClick={() => { setEditBan(b); setShowBanFm(false); }} variant="ghost" small>Edit</Btn>
              <Btn onClick={() => handleDeleteBanner(b)} variant="danger" small>Delete</Btn>
            </div>
          </div>
        ))
      }
    </div>
  );
}
